import { snackbarSuccess } from '../SharedFunctions';

export const handleAdminSuccess = (message: string) => {
    snackbarSuccess(message);
};
